import { render, staticRenderFns } from "./SubmissionsList.vue?vue&type=template&id=37597aba&scoped=true&"
import script from "./SubmissionsList.vue?vue&type=script&lang=js&"
export * from "./SubmissionsList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsList.vue?vue&type=style&index=0&id=37597aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37597aba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VPagination,VRow})
